import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  // Dropdown open state with delayed close to make hover easier
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const closeTimer = useRef(null);
  const membersCloseTimer = useRef(null);
  const [aboutOpen, setAboutOpen] = useState(false);
const aboutCloseTimer = useRef(null);

// Scroll detection
useEffect(() => {
  const handleScroll = () => {
    setIsScrolled(window.scrollY > 10);
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

const openAbout = () => {
  if (aboutCloseTimer.current) clearTimeout(aboutCloseTimer.current);
  setAboutOpen(true);
};

const closeAboutWithDelay = (delay = 450) => {
  if (aboutCloseTimer.current) clearTimeout(aboutCloseTimer.current);
  aboutCloseTimer.current = setTimeout(() => setAboutOpen(false), delay);
};

const toggleAbout = () => setAboutOpen(v => !v);

  const openMenu = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setMenuOpen(true);
  };

  const closeMenuWithDelay = (delay = 400) => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setMenuOpen(false), delay);
  };

  const toggleMenu = () => setMenuOpen((v) => !v);
  
  // Memberships dropdown controls
  const [membersOpen, setMembersOpen] = useState(false);
  const openMembers = () => {
    if (membersCloseTimer.current) clearTimeout(membersCloseTimer.current);
    setMembersOpen(true);
  };
  const closeMembersWithDelay = (delay = 450) => {
    if (membersCloseTimer.current) clearTimeout(membersCloseTimer.current);
    membersCloseTimer.current = setTimeout(() => setMembersOpen(false), delay);
  };
  const toggleMembers = () => setMembersOpen((v) => !v);
  const toggleMobile = () => setMobileOpen((v) => !v);

  return (
    <header className={`navbar ${isScrolled ? "navbar-scrolled" : ""}`}>
      <div className="nav-shell">
        {/* Brand */}
        <Link to="/" className="navbar-brand" aria-label="Forge Your Peak Home">
          <img src="/Logo.png" alt="Forge Your Peak" className="brand-logo" />
          <span className="brand-text">Forge Your Peak</span>
        </Link>

        {/* Center links */}
        <nav className="navbar-links" aria-label="Primary">
          <Link to="/why-us" className="navbar-link">Why Us</Link>
          <Link to="/benefits" className="navbar-link">Benefits</Link>

          {/* Measurement dropdown */}
          <div
            className={`nav-dropdown ${menuOpen ? "open" : ""}`}
            onMouseEnter={openMenu}
            onMouseLeave={() => closeMenuWithDelay(450)}
          >
            <span
              className="navbar-link nav-dropdown-trigger"
              role="button"
              aria-haspopup="true"
              aria-expanded={menuOpen ? "true" : "false"}
              onClick={toggleMenu}
            >
              Measurement ▾
            </span>
            <div className="nav-dropdown-menu" role="menu" onMouseEnter={openMenu} onMouseLeave={() => closeMenuWithDelay(450)}>
              <Link to="/visual-acuity" className="nav-dropdown-item" role="menuitem" onClick={() => setMenuOpen(false)}>Visual Acuity</Link>
              <Link to="/color-vision" className="nav-dropdown-item" role="menuitem" onClick={() => setMenuOpen(false)}>Color Vision Test</Link>
              <Link to="/contrast" className="nav-dropdown-item" role="menuitem" onClick={() => setMenuOpen(false)}>Contrast Sensitivity Test</Link>
              
              <Link to="/reactiongame" className="nav-dropdown-item" role="menuitem" onClick={() => setMenuOpen(false)}>Reaction Game</Link>
              <Link to="/complex-reaction" className="nav-dropdown-item" role="menuitem" onClick={() => setMenuOpen(false)}>Reaction Speed (Complex)</Link>
             
              <Link to="/short-term-memory" className="nav-dropdown-item" role="menuitem" onClick={() => setMenuOpen(false)}>Short-Term Visual Memory Test</Link>
              <Link to="/working-memory" className="nav-dropdown-item" role="menuitem" onClick={() => setMenuOpen(false)}>Working Memory Test</Link>
              <Link to="/search-span" className="nav-dropdown-item" role="menuitem" onClick={() => setMenuOpen(false)}>Search Span Test</Link>
              <Link to="/anticipation" className="nav-dropdown-item" role="menuitem" onClick={() => setMenuOpen(false)}>Anticipation Test</Link>
              
              
            </div>
          </div>

          {/* Memberships dropdown */}
          <div
            className={`nav-dropdown ${membersOpen ? "open" : ""}`}
            onMouseEnter={openMembers}
            onMouseLeave={() => closeMembersWithDelay(450)}
          >
            <span
              className="navbar-link nav-dropdown-trigger"
              role="button"
              aria-haspopup="true"
              aria-expanded={membersOpen ? "true" : "false"}
              onClick={toggleMembers}
            >
              Memberships ▾
            </span>
            <div className="nav-dropdown-menu" role="menu" onMouseEnter={openMembers} onMouseLeave={() => closeMembersWithDelay(450)}>
              <Link to="/bootcamp" className="nav-dropdown-item" role="menuitem" onClick={() => setMembersOpen(false)}>
                FYP - Bootcamp
              </Link>
              <Link to="/ignite" className="nav-dropdown-item" role="menuitem" onClick={() => setMembersOpen(false)}>FYP - Ignite</Link>
              <Link to="/vision-ignite" className="nav-dropdown-item"  role="menuitem" onClick={() => setMembersOpen(false)}>FYP - Vision Ignite</Link>
            </div>
          </div>
          <Link to="/leaderboard" className="navbar-link">
              Player Leaderboard
          </Link>
          <Link to="/report" className="navbar-link">
              Report
          </Link>
         
          {/* About dropdown */}
          <div
            className={`nav-dropdown ${aboutOpen ? "open" : ""}`}
            onMouseEnter={openAbout}
            onMouseLeave={() => closeAboutWithDelay(450)}
          >
            <span
              className="navbar-link nav-dropdown-trigger"
              onClick={toggleAbout}
            >
          
              About ▾
            </span>

            <div
              className="nav-dropdown-menu"
              onMouseEnter={openAbout}
              onMouseLeave={() => closeAboutWithDelay(450)}
            >
              <Link to="/about" className="nav-dropdown-item">
                About Community
              </Link>

              <Link to="/intro-booklet" className="nav-dropdown-item">
                Introduction Booklet
              </Link>
            </div>
          </div>
        </nav>

        {/* Mobile hamburger */}
        <button
          className={`nav-burger ${mobileOpen ? "active" : ""}`}
          aria-label="Open menu"
          aria-expanded={mobileOpen ? "true" : "false"}
          onClick={toggleMobile}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Right CTA */}
          <Link to="/dashboard-login" className="navbar-cta secondary">
            Performance Login
          </Link>
        <a
          href="https://learn.forgeyourpeak.in"
          className="navbar-cta"
          target="_blank"
          rel="noopener noreferrer"
        >
         Learn Login
        </a>
      </div>

      {/* Mobile slide-down menu */}
      {mobileOpen && (
        <div className="nav-mobile-panel" onClick={() => setMobileOpen(false)}>
          <div className="nav-mobile-inner" onClick={(e) => e.stopPropagation()}>
           <Link to="/why-us" className="nav-mobile-item" onClick={() => setMobileOpen(false)}> Why Us</Link>
           <Link to="/benefits" className="nav-mobile-item" onClick={() => setMobileOpen(false)}>Benefits</Link>
            <div className="nav-mobile-group">
              <div className="nav-mobile-label">Measurement</div>
              <Link to="/visual-acuity" className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>Visual Acuity</Link>
              <Link to="/color-vision" className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>Color Vision Test</Link>
              <Link to="/contrast" className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>Contrast Sensitivity Test</Link>
              <Link to="/reactiongame" className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>Reaction Game</Link>
              <Link to="/complex-reaction" className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>Reaction Speed (Complex)</Link>
             
              <Link to="/short-term-memory" className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>Short-Term Visual Memory Test</Link>
              <Link to="/working-memory" className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>Working Memory Test</Link>
              <Link to="/anticipation" className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>Anticipation Test</Link>
              <Link to="/search-span" className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>Search Span Test</Link>
            </div>
            <div className="nav-mobile-group">
              <div className="nav-mobile-label">Memberships</div>
              <Link to="/bootcamp" className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>
                FYP - Bootcamp
              </Link>
              <Link to="/ignite" className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>FYP - Ignite</Link>
              <Link to="/vision-ignite"  className="nav-mobile-subitem" onClick={() => setMobileOpen(false)}>FYP - Vision Ignite</Link>
            </div>
            <Link to="/leaderboard" className="nav-mobile-item" onClick={() => setMobileOpen(false)}  >
            player Leaderboard
            </Link>
            <Link to="/report" className="nav-mobile-item" onClick={() => setMobileOpen(false)} >
              Report
            </Link>
            <div className="nav-mobile-group">
            <div className="nav-mobile-label">About</div>

            <Link
              to="/about"
              className="nav-mobile-subitem"
              onClick={() => setMobileOpen(false)}
            >
              About Community
            </Link>

            <Link
              to="/intro-booklet"
              className="nav-mobile-subitem"
              onClick={() => setMobileOpen(false)}
            >
              Introduction Booklet
            </Link>
          </div>
            <a href="https://learn.forgeyourpeak.in" target="_blank" rel="noopener noreferrer" className="nav-mobile-cta" onClick={() => setMobileOpen(false)}>Learn</a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;